/** The app shell's announcer of activity copies (plan O13, `duplicateRuns`): the end of each
 *  run no popover shows, once, wherever the operator is — the copy with **Open the copy**, or
 *  that nothing was created. */
import { DuplicateWatcher } from './DuplicatePopover';
import { reportDuplicateRun, useDuplicateRuns } from './duplicateRuns';

/** Mounted once in the app shell: announces the end of each run no popover shows. */
export function DuplicateRunsHost() {
  const all = useDuplicateRuns();
  return (
    <>
      {all
        .filter((r) => !r.reported && !r.following)
        .map((r) => (
          <DuplicateWatcher
            key={r.taskId}
            run={r}
            sourceTitle={r.sourceTitle}
            onReported={() => reportDuplicateRun(r.activityId, r.taskId)}
          />
        ))}
    </>
  );
}
